export default __webpack_public_path__ + "static/media/sliderFull_noThemeSelected.954b6570.svg";